import React from "react";
import StfLessonPlan from "../../components/StaffTabs/StaffLessonPlan/StfLessonPlan"



const Notification = () => {
  return (
    <div>
      
      <StfLessonPlan/>
   
    </div>
  );
};


export default Notification;
